import api from '@/plugins/api';

export const services = {
  load: async function (filters) {
    try {
      const response = await api.get('/services', {
        params: filters
      })
      return response.data
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  update: async function (id, data) {
    try {
      const response = await api.patch(`/services/${id}`, data)
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
}

export default services
